import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import api from '@/api/api'
import { dictionary } from '@/shared/services/dictionary';
import UploadFile from '@/shared/services/oss.service';

import { Dialog } from 'vant';
@Component({
    components: {},
})
export default class AddResumeRecruitInfo extends Vue {
    @Prop() data: any; // 应聘信息
    @Prop() inResume: any; // 是否在录用简历过程中
    @Prop() areaList: any; // 地区信息
    schoolRecruitSourceList: any = []; // 校招应聘来源数据源
    intentionalPostList: any = []; // 意向岗位数据源
    areaProps: any = {}; // 省市组件属性
    radioList: any = [{ id: true, text: '是' }, { id: false, text: '否' }]; // radio选项
    fileLimit: any = { fileType: '*', fileLength: 1, fileSize: 8 }; // 附件限制
    fileList: any = []; // 已上传附件List
    fileURL: string = ''; // 附件url
    workPlacePlaceHolder: string = '请选择';
    recruitForm: any = { // 表单信息
        dataSource: '',
        expectedPosition: [],
        expectSalary: '',
        workPlaceList: [],
        isExpectPositionChange: '',
        isExpectWorkPlaceChange: '',
    };
    recruitRules: any = { // 表单验证
        dataSource: [
            { required: true, message: '请选择应聘信息来源', trigger: 'blur' }
        ],
        expectedPosition: [
            { required: true, message: '请选择期望的职位', trigger: 'blur' }
        ],
        expectSalary: [
            { required: true, message: '请输入期望的薪资', trigger: 'blur' }
        ],
        workPlaceList: [
            { required: true, message: '请选择意向工作地', trigger: 'blur' }
        ],
        isExpectPositionChange: [
            { required: true, message: '请选择是否接受岗位调剂', trigger: 'blur' }
        ],
        isExpectWorkPlaceChange: [
            { required: true, message: '请选择是否接受工作地调剂', trigger: 'blur' }
        ],
    };

    created() {
        // 校招应聘来源获取
        this.getRecruitSource();
        // 意向岗位获取
        this.getIntentionalPost();
        // 初始化省市信息
        this.initAreaInfo();
        // 赋值
        if (this.data) {
            this.recruitForm = this.data;
            if (this.data.workPlaces && this.data.workPlaces.length > 0) {
                this.recruitForm.workPlaceList = [this.data.workPlaces[0].proCode, this.data.workPlaces[0].cityCode];
                this.workPlacePlaceHolder = ((this.data.workPlaces[0].proName || this.data.workPlaces[0].cityName) ?
                    `${this.data.workPlaces[0].proName || ''} / ${this.data.workPlaces[0].cityName || ''}` : this.workPlacePlaceHolder);
            }
        }
    }

    // 监听简历信息变化
    @Watch('data')
    onDataChanged(val: any, oldVal: any) {
        this.recruitForm = val;
        if (val.workPlaces && val.workPlaces.length > 0) {
            this.recruitForm.workPlaceList = [val.workPlaces[0].proCode, val.workPlaces[0].cityCode];
            this.workPlacePlaceHolder = ((val.workPlaces[0].proName || val.workPlaces[0].cityName) ?
                `${val.workPlaces[0].proName || ''} / ${val.workPlaces[0].cityName || ''}` : this.workPlacePlaceHolder);
        }
    }

    // 应聘来源获取
    getRecruitSource() {
        // 应聘信息来源
        api.getDictionaries([dictionary.recruitSource]).then((res: any) => {
            this.schoolRecruitSourceList = res.data || [];
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '数据获取失败：' + error,
            });
        });
    }

    // 意向岗位来源获取
    getIntentionalPost() {
        api.getPositionsByEHR({ appKey: process.env.VUE_APP_EHR_APPKEY }).then((res: any) => {
            this.intentionalPostList = res.Data.map((x: any) => x.RecruitPosition);
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '数据获取失败：' + error,
            });
        });
    }

    // 初始化省市信息
    initAreaInfo() {
        this.areaProps = {
            expandTrigger: 'hover',
            label: 'name',
            value: 'code',
            lazy: true,
            lazyLoad(node: any, resolve: any) {
                const { level } = node;
                if (node.data && node.level < 2) {
                    api.getCityInfoById(node.data.id).then((res: any) => {
                        let nodes = res.districtDetails || null;
                        if (nodes && nodes.length > 0) {
                            nodes = nodes.map((item: any) => {
                                item.leaf = (node.level === 1)
                                return item
                            });
                        }
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }).catch((error: any) => {
                        Dialog.alert({
                            title: '提示',
                            message: '数据获取失败：' + error,
                        });
                    });
                } else {
                    resolve(null);
                }
            }
        };
    }

    // 更新input组件值，避免因组件嵌套太深出现input值未更新的情况
    updateInput() {
        this.$forceUpdate();
    }

    // 选择工作地
    changeWorkPlace(event: any) {
        const workPlaceNode = (this as any).$refs.workPlaceCascader.getCheckedNodes()[0];
        if (workPlaceNode && workPlaceNode.path) {
            this.recruitForm.workPlaces = [];
            const itemInfo = {
                proCode: workPlaceNode.path[0],
                cityCode: workPlaceNode.path[1],
                proName: workPlaceNode.pathLabels[0],
                cityName: workPlaceNode.pathLabels[1],
            }
            this.recruitForm.workPlaces[0] = itemInfo;
        }
        this.updateInput();
    }

    // 上传简历附件
    beforeFileUpload(file: any) {
        const fileSize = this.fileLimit.fileSize * 1024;
        if ((file.file.size / 1024) > fileSize) {
            this.$message({
                message: '附件最大为' + this.fileLimit.fileSize + 'M',
                type: 'warning'
            });
            this.fileList = [];
            return false;
        }
        UploadFile.addFileAliyun(file.file).then(
            (res: any) => {
                this.fileURL = res.url;
                const data = {
                    currentStep: 1,
                    fromInfo: this.recruitForm,
                    resumeFileURL: this.fileURL
                };
                this.$emit('getRecruitInfo', data);
            }
        )
        return false;
    }

    // 上传文件个数超过限度
    onExceed() {
        this.$message({
            message: '只能上传一份简历附件',
            type: 'warning'
        });
    }

    // 处理表单值
    setFormValue() {
        this.recruitForm.expectSalary = parseFloat(this.recruitForm.expectSalary);
    }

    // 在线填写（下一步）
    next(formName: any) {
        (this as any).$refs[formName].validate((valid: any) => {
            if (valid) {
                this.setFormValue();
                const data = {
                    currentStep: 1,
                    move: 'next',
                    fromInfo: this.recruitForm,
                    resumeFileURL: this.fileURL
                };
                this.$emit('getRecruitInfo', data);
            } else {
                return false;
            }
        });
    }
}
